import { useEffect, useState } from 'react';
import { Box, Container, Paper, Grid } from '@mui/material';
import { useForm, FieldValues, Controller, FieldErrors } from 'react-hook-form';
import { Link, useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';

import CustomButton from '../../../components/Button/button';
import CustomTextField from '../../../components/TextField/textField';
import CustomTypography from '../../../components/Typography/typography';
import styles from '../../../assets/styles/singing';
import { signin } from '../../../redux/slice/authSlice';
import logo from '../../../assets/images/logo1.png';
import ShowPassword from '../../../components/showPassword/ShowPassword';
const SignIn = () => {
  const [showPassword, setShowPassword] = useState(false);
  const navigate: any = useNavigate();
  const dispatch = useDispatch();
  const signinData = useSelector((state: any) => state.auth.signinData);
  const classes = styles();
  const form = useForm({
    defaultValues: {
      email: '',
      password: '',
    },
  });

  const { handleSubmit, control, formState, clearErrors } = form;
  const { errors, isSubmitting, isSubmitted } = formState;

  const onSubmit = async (data: FieldValues) => {
    const newData = { ...data, email: data.email.toLowerCase() };
    await dispatch(signin(newData));
  };

  const onError = (errors: FieldErrors) => {};

  useEffect(() => {
    if (signinData?.result?._id) {
      signinData?.result?.roleId === 1
        ? navigate('/admin/dashboard')
        : navigate('/dashboard');
    } else {
      const token =
        localStorage.getItem('profile') &&
        JSON.parse(localStorage.getItem('profile')!)?.token;
      if (token)
        JSON.parse(localStorage.getItem('profile')!)?.role === 1
          ? navigate('/admin/dashboard')
          : navigate('/dashboard');
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [signinData, isSubmitted]);

  return (
    <>
      <Container maxWidth='sm' className={classes.containerRoot}>
        <Box className={classes.Box}>
          <Paper className={classes.headingText} elevation={5}>
            <div className='heading-container'>
              <div>
                <CustomTypography variant='h3'>Sign In</CustomTypography>
                <CustomTypography
                  variant='body2'
                  align='center'
                  className='custom-margin'
                >
                  Not a member yet?
                  <Link className='customAuthLinkStyle' to='/signup'>
                    {' '}
                    Sign Up here
                  </Link>
                </CustomTypography>
              </div>
              <img alt='logo' src={logo} width={80} className='logo-image' />
            </div>

            <form onSubmit={handleSubmit(onSubmit, onError)}>
              <Grid container className={classes.GridContainer}>
                <Grid item xs={12} sm={12}>
                  <Controller
                    name='email'
                    control={control}
                    render={({ field }) => (
                      <CustomTextField
                        {...field}
                        label='Email'
                        fullWidth
                        value={field.value}
                        onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                          field.onChange(e.target.value, clearErrors('root'));
                        }}
                      />
                    )}
                    rules={{
                      required: {
                        value: true,
                        message: 'Please enter a email',
                      },
                      pattern: {
                        value: /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/g,
                        message: 'Please enter valid email',
                      },
                      validate: {
                        whitespace: (fieldValue: string) => {
                          return (
                            /^[ \t]+/.test(fieldValue) !== true ||
                            "Email can't be whitespace"
                          );
                        },
                      },
                    }}
                  />
                  <CustomTypography
                    variant='body2'
                    color={'red'}
                    align='justify'
                  >
                    {errors.email?.message?.toString()}
                  </CustomTypography>
                </Grid>
                <Grid item xs={12} sm={12}>
                  <Controller
                    name='password'
                    control={control}
                    render={({ field }) => (
                      <div className={classes.textInputContainer}>
                        <CustomTextField
                          {...field}
                          label='Password'
                          type={showPassword ? 'text' : 'password'}
                          fullWidth
                          onChange={(
                            e: React.ChangeEvent<HTMLInputElement>
                          ) => {
                            field.onChange(e.target.value, clearErrors('root'));
                          }}
                        />
                        <ShowPassword
                          showPassword={showPassword}
                          onClick={() => setShowPassword(!showPassword)}
                        />
                      </div>
                    )}
                    rules={{
                      required: {
                        value: true,
                        message: 'Please enter a password',
                      },

                      validate: {
                        whitespace: (fieldValue: string) => {
                          return (
                            /^[ \t]+/.test(fieldValue) !== true ||
                            "Password can't be whitespace"
                          );
                        },
                      },
                    }}
                  />
                  <CustomTypography variant='body2' color='red' align='justify'>
                    {errors.password?.message?.toString()}
                  </CustomTypography>
                </Grid>

                <CustomButton
                  sx={{ mt: 2 }}
                  type='submit'
                  fullWidth
                  color='primary'
                  disabled={isSubmitting}
                >
                  {' '}
                  Sign In
                </CustomButton>
              </Grid>
            </form>

            <CustomTypography align='right' className={classes.GridContainer}>
              <Link to='/forgotpassword' className='customAuthLinkStyle'>
                <CustomButton variant='text' color='primary'>
                  Forgot password?
                </CustomButton>
              </Link>
            </CustomTypography>
          </Paper>
        </Box>
      </Container>
    </>
  );
};

export default SignIn;
